<template>
  <v-dialog :value="visiblePopup" max-width="500px" @input="onDialogInput">
    <v-card>
      <v-card-title>
        <span class="headline">{{ $t('add.new.keyword.popup.title') }}</span>
      </v-card-title>
      <v-card-text>
        <div v-if="!isLimitReached">
          <v-text-field
            v-model="keyword"
            :label="$t('add.new.keyword.popup.input.label')"
            required
            @keyup.enter="saveKeyword"
            @keyup.esc="closeAddKeywordPopup"
            ref="keywordInput"
            class="add-keyword-popup-field"
          ></v-text-field>
          <div class="remaining-slots" v-if="validationStatus.remainingSlots > 0">
            {{ validationStatus.message }}
          </div>
        </div>
        <div v-else class="limit-reached-message error--text">
          {{ validationStatus.message }}
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="btn-tertiary" @click="closeAddKeywordPopup">{{ $t('cancel') }}</v-btn>
        <v-btn class="btn-primary" @click="saveKeyword" :disabled="!isValid || isLimitReached">{{ $t('save') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { validateKeywordsLimit, isKeywordsLimitReached } from '@/utils/socialMediaUtils';

export default {
  name: 'AddKeywordPopup',
  props: {
    visiblePopup: {
      type: Boolean,
      required: true,
    },
    currentKeywords: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      keyword: '',
    };
  },
  computed: {
    validationStatus() {
      return validateKeywordsLimit(this.currentKeywords);
    },
    isLimitReached() {
      return isKeywordsLimitReached(this.currentKeywords);
    },
    isValid() {
      return this.keyword.trim();
    },
  },
  methods: {
    closeAddKeywordPopup() {
      this.keyword = '';
      this.$emit('closeAddKeywordPopup');
    },
    // handles backdrop click / ESC — Vuetify emits false via @input
    onDialogInput(val) {
      if (!val) this.closeAddKeywordPopup();
    },
    saveKeyword() {
      if (this.keyword.trim() && !this.isLimitReached) {
        this.$emit('saveAddKeyword', [{ keyword: this.keyword.trim() }]);
        this.keyword = '';
      }
    },
  },
  watch: {
    visiblePopup(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          if (!this.isLimitReached && this.$refs.keywordInput) {
            this.$refs.keywordInput.focus();
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.remaining-slots {
  margin-top: $space-2;
  font-size: $font-size-sm;
  color: var(--text-secondary);
}

.limit-reached-message {
  margin-top: $space-2;
  font-size: $font-size-base;
}
</style>

<style lang="scss">
@import '~@/assets/styles/design-system';

.add-keyword-popup-field {
  .v-label {
    color: var(--text-secondary) !important;
    top: 4px !important;
  }
  &.v-input--is-focused .v-label,
  &.v-input--is-dirty .v-label {
    color: var(--text-secondary) !important;
    top: 4px !important;
  }
  &.error--text .v-label {
    color: var(--severity-critical) !important;
  }
}
</style>
